import React, {
  useEffect,
  useState,
  useCallback,
  useReducer, forwardRef, useImperativeHandle,
} from 'react';
import Box from '@mui/material/Box';
import {
  Button,
  Button as MUIButton,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import {SlidingPaneEdit} from '../Page/SlidingPaneEdit';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import api from '../../services/api';
import {Entity} from '../../types/entities/Entity';
import {Schema} from '../../types/Schema';
import {SchemaWithClient} from '../../types/SchemaWithClient';
import {useStateContext} from '../../hooks/useStateContext';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import CloseFullscreenRoundedIcon from '@mui/icons-material/CloseFullscreenRounded';
import OpenInFullRoundedIcon from '@mui/icons-material/OpenInFullRounded';
import CloseIcon from '@mui/icons-material/Close';
import {SendModification} from '../EntityDialog/SendModification';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import {SlidePaneSkeleton} from '../Loading/SlidePaneSkeleton';
import SendIcon from '@mui/icons-material/Send';
import {debounce} from 'lodash';
import toast from 'react-hot-toast';
import {UpdateAddressDialog} from "../ServiceReservation/UpdateAddressDialog";
import {hasPermissionByPriority} from "../../core/permissions/hasPermission";
import {ROLE_PRIORITIES} from "../../core/permissions/permissions";
import {ChangeTabConfirmDialog} from "./ChangeTabConfirmDialog";
import PendingRowUpdateDialog from "../Table/layout/PendingRowUpdateDialog";
import PendingRowUpdateStatusDialog from "../Table/layout/PendingRowUpdateStatusDialog";
import {hasPermissionId} from "../../core/permissions/hasPermissionId";

function CustomTabPanel(props: any) {
  const {
    children,
    value,
    index,
    loadingSave,
    isDialog,
    modified,
    isLocked,
    ...other
  } = props;
  const {sideBarPosition} = useStateContext();

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      className={'p-[0px]'}
      {...other}
    >
      {value === index && (
        <Box
          sx={{
            height: {
              xs: `calc(100vh - ${modified ? '140px' : '80px'})`,
              md: `calc(100vh - ${modified ? '140px' : '120px'})`,
              lg: `calc(100vh - ${
                isDialog
                  ? modified
                    ? '400px'
                    : '354px'
                  : modified
                    ? '140px'
                    : '120px'
              })`,
            },
            overflowY: 'auto',
            padding: '10px',
            opacity: isLocked ? 0.6 : 1,
            pointerEvents: isLocked ? 'none' : 'all',
          }}
        >
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const reducer = (state: any, action: any) => {
  switch (action.type) {
    case 'SET_INPUT':
      const newCurrent = {
        ...state.current,
        [action.payload.column]: action.payload.value,
      };
      const newHistory = {
        ...state.history,
        [action.payload.column]: action.payload.value,
      };

      if (action.payload.column === 'unit_price') {
        if (action.payload.value && state.current?.vat) {
          newCurrent['unit_price_gross'] = parseFloat(
            (action.payload.value * (state.current?.vat / 100 + 1)).toFixed(2)
          );
          newHistory['unit_price_gross'] = parseFloat(
            (action.payload.value * (state.current?.vat / 100 + 1)).toFixed(2)
          );
        }
      }
      if (action.payload.column === 'unit_price_gross') {
        if (action.payload.value && state.current?.vat) {
          newCurrent['unit_price'] = parseFloat(
            (action.payload.value / (1 + state.current?.vat / 100)).toFixed(2)
          );
          newHistory['unit_price'] = parseFloat(
            (action.payload.value / (1 + state.current?.vat / 100)).toFixed(2)
          );
        }
      }
      if (action.payload.column === 'vat') {
        if (newCurrent?.unit_price) {
          newCurrent['unit_price_gross'] = parseFloat(
            (newCurrent?.unit_price * (action.payload.value / 100 + 1)).toFixed(
              2
            )
          );
          newHistory['unit_price_gross'] = parseFloat(
            (newCurrent?.unit_price * (action.payload.value / 100 + 1)).toFixed(
              2
            )
          );
        } else if (newCurrent?.unit_price_gross) {
          newCurrent['unit_price'] = parseFloat(
            (
              newCurrent?.unit_price_gross /
              (1 + action.payload.value / 100)
            ).toFixed(2)
          );
          newHistory['unit_price'] = parseFloat(
            (
              newCurrent?.unit_price_gross /
              (1 + action.payload.value / 100)
            ).toFixed(2)
          );
        }
      }
      if (action.payload.column === 'group_price' && action.payload.split) {
        newCurrent[`prices`] = {};
        newHistory[`prices`] = {};
        for (let i = 1; i < 51; i++) {
          const price = parseFloat((action.payload?.value / i).toFixed(2));
          newCurrent[`prices`][`size_${i}`] = price;
          newHistory[`prices`][`size_${i}`] = price;
        }
      }


      if (action.payload.column === 'total_price') {
        const dep = state.current.departure;
        const arr = state.current.arrival;
        const size = state.current.size;

        if (dep && arr && size) {
          const depDate = new Date(dep);
          const arrDate = new Date(arr);

          const differenceInTime = depDate.getTime() - arrDate.getTime();
          const differenceInDays = differenceInTime / (1000 * 60 * 60 * 24);

          const nights = Math.max(1, differenceInDays);

          newCurrent['sales_price_person_night'] = (action.payload.value / nights) / size;
          newHistory['sales_price_person_night'] = (action.payload.value / nights) / size;
        }

      }

      if (action.payload.column === 'sales_price_person_night') {
        const dep = state.current.departure;
        const arr = state.current.arrival;
        const size = state.current.size;

        if (dep && arr && size) {
          const depDate = new Date(dep);
          const arrDate = new Date(arr);

          const differenceInTime = depDate.getTime() - arrDate.getTime();
          const differenceInDays = differenceInTime / (1000 * 60 * 60 * 24);

          const nights = Math.max(1, differenceInDays);

          newCurrent['total_price'] = (action.payload.value * nights) * size;
          newHistory['total_price'] = (action.payload.value * nights) * size;
        }

      }
      if (action.payload.column === 'price_per_person_per_night') {
        const size = state.current?.accommodation_reservation?.size;
        if (size) {
          newCurrent['price_per_night'] = (action.payload.value) * size;
          newHistory['price_per_night'] = (action.payload.value) * size;
        }


      }

      if (action.payload.column === 'price_per_night') {

        const dep = state.current?.accommodation_reservation?.departure;
        const arr = state.current?.accommodation_reservation?.arrival;
        const size = state.current?.accommodation_reservation?.size;

        if (dep && arr && size) {
          newCurrent['price_per_person_per_night'] = (action.payload.value) / size;
          newHistory['price_per_person_per_night'] = (action.payload.value) / size;
        }

      }


      if (action.payload.column === 'total_cost') {
        const dep = state.current.departure;
        const arr = state.current.arrival;
        const size = state.current.size;

        if (dep && arr && size) {
          const depDate = new Date(dep);
          const arrDate = new Date(arr);

          const differenceInTime = depDate.getTime() - arrDate.getTime();
          const differenceInDays = differenceInTime / (1000 * 60 * 60 * 24);

          const nights = Math.max(1, differenceInDays);

          newCurrent['gross_cost_person_night'] = (action.payload.value / nights) / size;
          newHistory['gross_cost_person_night'] = (action.payload.value / nights) / size;
        }

      }

      if (action.payload.column === 'gross_cost_person_night') {
        const dep = state.current.departure;
        const arr = state.current.arrival;
        const size = state.current.size;

        if (dep && arr && size) {
          const depDate = new Date(dep);
          const arrDate = new Date(arr);

          const differenceInTime = depDate.getTime() - arrDate.getTime();
          const differenceInDays = differenceInTime / (1000 * 60 * 60 * 24);

          const nights = Math.max(1, differenceInDays);

          newCurrent['total_cost'] = (action.payload.value * nights) * size;
          newHistory['total_cost'] = (action.payload.value * nights) * size;
        }

      }

      if (action?.schema && (action?.schema?.name === 'Services' || action?.schema?.name === 'Activity') && action.payload.column === 'name') {
        newCurrent['sp_name'] = action.payload.value;
      }

      return {
        ...state,
        history: newHistory,
        current: newCurrent,
        lastChanged: action.payload.column,
      };

    case 'SET_DEFAULT':
      return {
        ...state,
        current: action.payload,
        history: {},
        lastChanged: undefined,
      };

    case 'SET_HISTORY':
      return {
        ...state,
        history: action.payload,
        lastChanged: undefined,
      };

    default:
      return state;
  }
};

interface MinimizedContentProps {
  schema: any;
  propertiesFromTable: any;
  hasSlidingPane?: boolean;
  handleSubmit: (item: any, dialog?: string) => void;
  onClose: (item: any) => void;
  onChangeFullWidth: (value: boolean) => void;
  id: number | undefined | string;
  hasFullScreen: boolean;
  refreshMainTable?: () => void;
  isDialog?: any;
  demo?: any;
  isLocked?: any;
  hasUnsavedModifications?: (value: any) => void;
}

const MinimizedContent = forwardRef((props: MinimizedContentProps, ref: any) => {

  const {
    schema,
    propertiesFromTable,
    handleSubmit,
    hasSlidingPane,
    onClose,
    id,
    onChangeFullWidth,
    hasFullScreen,
    refreshMainTable,
    isDialog,
    demo,
    isLocked,
    hasUnsavedModifications,
  } = props;

  useImperativeHandle(ref, () => ({
    handleSubmit: (value: any) => {
      onSubmit();
    },
  }));

  const [loading, setLoading] = useState(true);
  const [properties, setProperties] = useState<any>({});
  const [confirmBeforeUpdateRowDialog, setConfirmBeforeUpdateRowDialog] = useState<any>(null);
  const [confirmBeforeUpdateRowDialogType, setConfirmBeforeUpdateRowDialogType] = useState<any>(null);
  const [confirmBeforeUpdateRowDialogOpen, setConfirmBeforeUpdateRowDialogOpen] = useState<boolean>(false);
  const [previousProperties, setPreviousProperties] = useState<Partial<any>>({});
  const [modified, setModified] = useState(false);
  const [showSendNotification, setShowSendNotification] = useState(false);
  const [showSendNotificationButton, setShowSendNotificationButton] = useState(
    false
  );
  const [openConfirmDialog, setOpenConfirmDialog] = useState<any>(false);
  const [requiredFieldsFromDatabase, setRequiredFieldsFromDatabase] = useState<
    any
  >([]);
  const {user} = useStateContext();
  const [openedSlidingPane, setOpenedSlidingPane] = useState<any>({});

  const [fullWidth, setFullWidth] = useState(false);
  const [missingFields, setMissingFields] = useState<
    Array<keyof typeof schema.columns>
  >([]);
  const [value, setValue] = React.useState(0);
  const [disabledFunctions, setDisabledFunctions] = React.useState(false);

  const [state, dispatch] = useReducer(reducer, {
    history: [],
    current: undefined,
  });

  const [loadingSave, setLoadingSave] = useState(false);
  const [customFields, setCustomFields] = useState<any>(undefined);
  const [forcedValue, setForcedValue] = useState<any>(false);
  const [changeTabOpenConfirmDialog, setChangeTabOpenConfirmDialog] = useState<any>(false);
  const [confirmPriceSplit, setConfirmPriceSplit] = useState({
    open: false,
    data: {},
  });
  const [confirmServiceReservationChangeAddress, setConfirmServiceReservationChangeAddress] = useState({
    open: false,
    type: false,
    data: {},
  });

  const isAdmin = hasPermissionByPriority(user.roles, ROLE_PRIORITIES[1]);

  const getMissingFields = useCallback(async () => {
    const requiredFieldFromView = await api
      .get(`/required-fields/${user.id}/${schema?.viewTable}`)
      .then((res: any) => {
        setRequiredFieldsFromDatabase(res);
        return res;
      })
      .catch((errors) => {
        console.log(errors);
      });

    const columnKeys: any = schema?.columns
      ? (Object.keys(schema.columns) as Array<any>)
      : [];

    const requiredFields = columnKeys.filter((columnKey: string) => {
      const column: any = schema.columns[columnKey as keyof {}];

      const required = requiredFieldFromView[`${columnKey}`];

      if (schema?.viewTable) {
        return required;
      }

      return column.required && !column.readOnly;
    });

    return requiredFields.filter(
      (requiredField: any) =>
        properties[requiredField] === undefined ||
        properties[requiredField] === null ||
        properties[requiredField] === ''
    );
  }, [properties]);

  const fetchSchema = useCallback(() => {
    setLoading(true);
    const searchParams = new URLSearchParams({});

    try {
      schema.client.readOne(propertiesFromTable?.id).then((res: any) => {
        if (res?.custom_fields) {
          setCustomFields(res?.custom_fields);
        }

        const tempRes: any = {...res};
        if (schema?.name === 'Accommodation Address') {
          tempRes.accommodation = propertiesFromTable?.accommodation;
        }

        dispatch({
          type: 'SET_DEFAULT',
          payload: tempRes,
        });
        dispatch({
          type: 'SET_HISTORY',
          payload: {},
        });
        setModified(false);
        setLoading(false);
      });
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  }, [schema, propertiesFromTable]);

  const splitPrice = useCallback(
    (split: boolean) => {
      const value = confirmPriceSplit.data;
      const column = 'group_price';

      dispatch({type: 'SET_INPUT', payload: {column, value, split}, schema: schema});
    },
    [state, confirmPriceSplit]
  );

  const onSubmit = useCallback(async () => {
    if (schemaHasClient(schema)) {
      setLoadingSave(true);

      const sendData: any = {
        ...state.history,
        ['schemaColumns']: schema?.columns,
      };
      if (schema.name === 'Service - Event Staff') {
        sendData.service_provider = {id: properties?.service_provider_id};
      }

      await schema.client
        .update(propertiesFromTable['id'] as number, sendData)
        .then((res: any) => {
          if (sendData?.address_from) {
            handleSubmit(res, 'address');
          } else {
            handleSubmit(res);
          }

          const failedFieldsArray: any = res?.unsaved_fields
            ? {...res.unsaved_fields}
            : {};

          Object.keys(failedFieldsArray).map((field: any) => {
            const messages: any = failedFieldsArray[field];

            const valueForSave: any = propertiesFromTable[`${field}`] || null;

            dispatch({type: 'SET_INPUT', payload: {field, valueForSave}, schema: schema});

            messages.map((failed: any) => {
              toast.error(failed);
            });
          });

        })
        .catch((error: any) => {
          let array: any = [];
          for (let errorKey in error) {
            for (let errorMsg in error[errorKey]) {
              array.push(`${error[errorKey][errorMsg]}`);
            }
          }
          toast.error(array.join(','));
        })
        .finally(() => {
          dispatch({
            type: 'SET_HISTORY',
            payload: {},
          });
          setModified(false);
          setLoadingSave(false);
        });
    }
  }, [getMissingFields, state, schema]);

  useEffect(() => {
    setProperties(propertiesFromTable);
  }, []);

  useEffect(() => {
    (Object.keys(previousProperties) as Array<any>).map((column) => {
      if (column === 'service_provider' && modified) {
        setProperties({...properties, [column]: undefined});
      }
    });

    if (hasUnsavedModifications) {
      hasUnsavedModifications(modified);
    }

  }, [modified]);

  useEffect(() => {
    if (schema?.viewTable) {
      api
        .get(`/required-fields/${user.id}/${schema?.viewTable}`)
        .then((res: any) => {
          setRequiredFieldsFromDatabase(res);
        });
    }
  }, []);

  useEffect(() => {

    const debouncedFetch = debounce(() => {
      fetchSchema();
    }, 200);

    debouncedFetch();
    return () => {
      debouncedFetch.cancel();
    };

  }, [propertiesFromTable]);

  function handleOpenInFull() {
    const value = !fullWidth;
    setFullWidth(!value);
    onChangeFullWidth(value);
  }

  function handleSetChanges(column: any, value: any) {
    if (column === 'start_time') {
      setConfirmBeforeUpdateRowDialog(properties);
    }

    if (schema?.viewTable === 'service_reservations' && column === 'service_reservation_status' && value?.id === 6) {
      setConfirmBeforeUpdateRowDialog(properties);
      setConfirmBeforeUpdateRowDialogType('status');
    }

    if (column === 'group_price') {
      setConfirmPriceSplit({
        open: true,
        data: value,
      });
    } else {
      dispatch({type: 'SET_INPUT', payload: {column, value}, schema: schema});
    }
  }

  const debouncedChange = useCallback(
    debounce(() => {
      if (!modified && Object.keys(state.history).length) {
        setModified(true);
      }
    }, 100),
    [state, modified]
  );

  useEffect(() => {
    debouncedChange();

    if (state.lastChanged === 'group_price' && confirmPriceSplit.open) {
      setForcedValue(state.current.group_price);

      setConfirmPriceSplit({
        open: false,
        data: {},
      });
    }

  }, [state, debouncedChange]);

  const handleChange = (newValue: number) => {
    setValue(newValue);
  };
  const handleClearHistory = () => {
    dispatch({
      type: 'SET_HISTORY',
      payload: {},
    });
    setModified(false);
    setLoadingSave(false);
  };

  return (
    <>
      <Stack
        direction={'row'}
        alignItems={'center'}
        justifyContent={'space-between'}
        sx={{
          background: '#256861',
          color: '#fff',
          px: '10px',
          opacity: loadingSave ? 0.6 : 1,
          pointerEvents: loadingSave ? 'none' : 'auto',
          filter: loadingSave ? 'grayscale(1)' : 'none',
          userSelect: 'none',
        }}
      >
        <Stack direction={'row'} alignItems={'center'}>
          <IconButton
            aria-label="Open in full"
            sx={{
              color: '#fff',
            }}
            onClick={() => {
              handleOpenInFull();
            }}
            disabled={!hasFullScreen}
          >
            {fullWidth ? (
              <CloseFullscreenRoundedIcon/>
            ) : (
              <OpenInFullRoundedIcon/>
            )}
          </IconButton>
          <Typography variant="subtitle1">
            <>
              <span>Edit {schema?.name}</span>
              {state.current && state.current?.name && (
                <span>// {state.current?.name}</span>
              )}
            </>
          </Typography>
        </Stack>
        <Stack direction={'row'} alignItems={'center'}>
          {showSendNotificationButton && (
            <IconButton
              aria-label="Sent"
              sx={{
                color: '#fff',
              }}
              onClick={() => {
                setShowSendNotification(true);
              }}
            >
              <EmailOutlinedIcon/>
            </IconButton>
          )}
          <IconButton
            aria-label="Close"
            color="primary"
            onClick={() => {
              if (modified) {
                setOpenConfirmDialog(true);
              } else {
                onClose(true);
              }
            }}
          >
            <CloseIcon
              sx={{
                color: '#fff',
              }}
            />
          </IconButton>
        </Stack>
      </Stack>
      <Box
        sx={{
          p: '0px',
          opacity: loadingSave ? 0.6 : 1,
          pointerEvents: loadingSave ? 'none' : 'auto',
          filter: loadingSave ? 'grayscale(1)' : 'none',
          userSelect: 'none',
          '& .DraftEditor-root': {
            padding: '10px',
          },
        }}
      >
        <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
          <Tabs
            value={value}
            onChange={(event, value) => {

              if (modified) {
                setChangeTabOpenConfirmDialog(value);
                return;
              }
              handleClearHistory();
              handleChange(value);
            }}
          >
            {schema.tabs &&
              schema.tabs.map((tab: any, index: any) => {
                return (
                  <Tab
                    key={index}
                    disabled={disabledFunctions}
                    label={tab.label}
                    {...a11yProps(index)}
                  />
                );
              })}
          </Tabs>
        </Box>

        {loading ? (
          <SlidePaneSkeleton/>
        ) : (
          <>
            {schema?.tabs && (
              <>
                {schema.tabs.map((tab: any, index: any) => {
                  const {renderer: Component} = tab;

                  return (
                    <>
                      <CustomTabPanel
                        isDialog={isDialog}
                        modified={modified}
                        value={value}
                        index={index}
                        key={index}
                        isLocked={isLocked}
                      >
                        {tab?.type === 'custom' ? (
                          <>
                            <Component
                              schema={schema}
                              values={propertiesFromTable}
                              tableType={tab?.rendererType}
                              modified={modified}
                              isLocked={isLocked}
                              onChange={(column: string, value: any) => {
                                handleSetChanges(column, value);
                              }}
                              refreshMainTable={() => {
                                if (refreshMainTable) {
                                  refreshMainTable();
                                }
                              }}
                            />
                          </>
                        ) : (
                          <>
                            {(Object.keys(schema.columns) as Array<any>).map((column, index: number) => {
                              const tabName = schema.columns[column]?.tab_name
                                ? schema.columns[column]?.tab_name
                                : 'general';

                              const withoutNameColumn =
                                schema.columns[column]?.withoutNameColumn;

                              if (tab?.name !== tabName) {
                                return <></>;
                              }
                              const {
                                readOnly,
                                name,
                                fieldRenderer: Field,
                                slidePaneFieldRenderer: FieldForPane,
                                accordingTo,
                                hide,
                                nameForSidePane,
                                required,
                                style,
                                editOnlyByAdmin,
                                editOnlyByAdminOrTcFinance,
                              } = schema.columns[column];

                              const isMissing = missingFields.includes(column);

                              const key: any = accordingTo;
                              let accordingToHide = false;
                              if (typeof accordingTo !== 'undefined') {
                                accordingToHide = true;
                              }

                              if (
                                accordingToHide &&
                                schema?.name === 'Service Reservations View' &&
                                column === 'service_provider'
                              ) {
                                accordingToHide = false;
                              }

                              let accordingToSendData: any = undefined;

                              if (
                                state.current[key] !== undefined &&
                                state.current[key] !== null &&
                                state.current[key] !== ''
                              ) {
                                accordingToHide = false;
                                const accordingToData: any = state.current[key];
                                accordingToSendData = {
                                  name: key,
                                  id: accordingToData?.id,
                                  value: accordingToData,
                                };
                              }

                              let readOnlyTemp = (!isAdmin && editOnlyByAdmin) ? true : readOnly;

                              if (schema?.viewTable === 'activity_reservations' && column === 'activity') {
                                readOnlyTemp = true;
                              }

                              if (
                                schema?.viewTable === 'service_reservations' &&
                                column === 'selected_staff'
                              ) {
                                readOnlyTemp = true;
                                if (
                                  state.current?.is_guide
                                  && !state.current?.selected_staff?.id
                                ){
                                  readOnlyTemp = false;
                                }

                              }

                              /* if (column === 'service_reservation_status'){
                                 readOnlyTemp = true;
                                 if (isAdmin){
                                   readOnlyTemp = false;
                                 }
                                 if (state.current['service_provider'] && state.current['service_provider']['dont_send_confirmation']){
                                   readOnlyTemp = false;
                                 }
                               }*/

                              return (
                                <>
                                  <Stack
                                    key={index}
                                    direction="row"
                                    spacing={0}
                                    sx={{
                                      width: '100%',
                                      display: hide ? 'none' : '',
                                      background: style?.background
                                        ? style.background
                                        : '',
                                      color: style?.color && style.color,
                                      '& .MuiInputBase-root.MuiOutlinedInput-root': {
                                        color: style?.color && style.color,
                                      },
                                      marginBottom:
                                        style?.marginBottom &&
                                        style.marginBottom,
                                    }}
                                  >
                                    {!withoutNameColumn && (
                                      <Box
                                        sx={{
                                          flex: 1,
                                          borderBottom: '1px solid #dfdbdb',
                                          borderRight: '1px solid #dfdbdb',
                                          borderLeft: '1px solid #dfdbdb',
                                          display: 'flex',
                                          alignItems: 'center',
                                          background: style?.background
                                            ? style.background
                                            : '#f1f1f1',
                                          color: style?.color && style.color,
                                          fontSize: {
                                            xs: '15px',
                                          },
                                        }}
                                      >
                                        <span className={'px-[8px]'}>{`${
                                          nameForSidePane
                                            ? nameForSidePane
                                            : name
                                        } ${
                                          requiredFieldsFromDatabase[column] ||
                                          required
                                            ? '*'
                                            : ''
                                        }`}</span>
                                        {isMissing && (
                                          <span style={{color: 'red'}}>
                                            This field is missing
                                          </span>
                                        )}
                                      </Box>
                                    )}

                                    <Box
                                      sx={{
                                        flex: 2,
                                        borderBottom: '1px solid #dfdbdb',
                                        borderRight: '1px solid #dfdbdb',
                                        '& .MuiFormControl-root.MuiTextField-root': {
                                          width: '100%',
                                        },
                                        maxWidth: {
                                          xs: !withoutNameColumn
                                            ? 'calc(100% - 130px)'
                                            : '100%',
                                          md: !withoutNameColumn
                                            ? 'calc(100% - 204px)'
                                            : '100%',
                                        },
                                      }}
                                    >
                                      {FieldForPane ? (
                                        <>
                                          <FieldForPane
                                            onChange={(
                                              value: any,
                                              columnName: any
                                            ) => {
                                              handleSetChanges(
                                                columnName
                                                  ? columnName
                                                  : column,
                                                value
                                              );
                                            }}
                                            values={state.current}
                                            defaultValue={state.current[column]}
                                            forcedValue={forcedValue}
                                            allValue={state.current}
                                            mainSchema={schema}
                                            minimized={true}
                                            accordingToValue={
                                              accordingToSendData
                                            }
                                            disabled={readOnlyTemp}
                                            column={schema.columns[column]}
                                            columnName={column}
                                            refreshMainTableData={() => {
                                              handleSubmit(true);
                                            }}
                                          />
                                        </>
                                      ) : (
                                        <></>
                                      )}
                                    </Box>
                                  </Stack>
                                </>
                              );
                            })}
                          </>
                        )}
                      </CustomTabPanel>
                    </>
                  );
                })}
              </>
            )}
          </>
        )}

        <Box
          sx={{
            position: 'sticky',
            bottom: '0px',
            zIndex: '999',
          }}
        >
          {modified && (
            <Stack
              direction={'row'}
              alignItems={'center'}
              justifyContent={'space-between'}
              sx={{
                background: '#fff',
                px: '20px',
                py: '5px',
                opacity: loadingSave ? 0.6 : 1,
                pointerEvents: loadingSave ? 'none' : 'auto',
                borderTop: '1px solid #e0e0e0',
                boxShadow: '0px -4px 10px 0px #00000017',
              }}
            >
              <Stack direction={'row'} alignItems={'center'}></Stack>
              <Stack direction={'row'} alignItems={'center'}>
                <Button
                  variant="contained"
                  endIcon={<SendIcon/>}
                  onClick={() => {
                    if (demo) {
                      handleSubmit(state.current);
                    } else {
                      if (confirmBeforeUpdateRowDialog) {
                        setConfirmBeforeUpdateRowDialogOpen(true);
                      } else {
                        onSubmit();
                      }
                    }
                  }}
                >
                  Save
                </Button>
              </Stack>
            </Stack>
          )}
        </Box>
      </Box>

      {openedSlidingPane?.row?.id && (
        <SlidingPaneEdit
          schema={openedSlidingPane?.schema}
          id={openedSlidingPane?.row?.id}
          onSubmit={(value) => {
            fetchSchema();
            setOpenedSlidingPane({});
          }}
          propertiesFromTable={
            openedSlidingPane?.row ? openedSlidingPane?.row : {}
          }
          onClose={(value) => {
            setOpenedSlidingPane({});
          }}
        />
      )}

      {confirmPriceSplit && (
        <Dialog
          open={confirmPriceSplit?.open}
          onClose={() => {
            setConfirmPriceSplit({
              open: false,
              data: {},
            });
          }}
        >
          <DialogTitle>{'Split the prices?'}</DialogTitle>
          <DialogActions
            sx={{
              gap: '10px',
              flexDirection: {
                xs: 'column',
                md: 'row',
              },
            }}
          >
            <MUIButton
              variant={'outlined'}
              color={'error'}
              onClick={() => {
                splitPrice(false);
              }}
              sx={{
                ml: '0px !important',
                width: {
                  xs: '100%',
                  md: '240px',
                },
              }}
            >
              No
            </MUIButton>
            <MUIButton
              variant={'contained'}
              color={'primary'}
              onClick={() => {
                splitPrice(true);
              }}
              sx={{
                ml: '0px !important',
                width: {
                  xs: '100%',
                  md: '180px',
                },
              }}
              autoFocus
            >
              Yes
            </MUIButton>
          </DialogActions>
        </Dialog>
      )}
      {confirmServiceReservationChangeAddress.open && (
        <>
          <UpdateAddressDialog params={confirmServiceReservationChangeAddress}
                               onClose={() => setConfirmServiceReservationChangeAddress({
                                 ...confirmServiceReservationChangeAddress,
                                 open: false
                               })}/>
        </>
      )}

      {changeTabOpenConfirmDialog !== false && (
        <ChangeTabConfirmDialog
          onClose={() => {
            setChangeTabOpenConfirmDialog(false);
          }}
          onSubmit={() => {
            onSubmit();
            handleChange(changeTabOpenConfirmDialog);
            setChangeTabOpenConfirmDialog(false);
          }}
          onCloseWithOutSaving={() => {
            handleClearHistory();
            handleChange(changeTabOpenConfirmDialog);
            setChangeTabOpenConfirmDialog(false);
          }}
        />
      )}

      {openConfirmDialog && (
        <Dialog
          open={openConfirmDialog}
          onClose={() => {
            setOpenConfirmDialog(false);
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {
              'You have unsaved changes. Please save your work before leaving. Do you want to close without saving?'
            }
          </DialogTitle>
          <DialogActions
            sx={{
              gap: '10px',
              flexDirection: {
                xs: 'column',
                md: 'row',
              },
            }}
          >
            <MUIButton
              variant={'outlined'}
              onClick={() => {
                setOpenConfirmDialog(false);
              }}
              sx={{
                width: {
                  xs: '100%',
                  md: '100px',
                },
              }}
            >
              Cancel
            </MUIButton>
            <MUIButton
              variant={'outlined'}
              color={'error'}
              onClick={() => {
                onClose(false);
              }}
              sx={{
                ml: '0px !important',
                width: {
                  xs: '100%',
                  md: '240px',
                },
              }}
            >
              Close Without Saving
            </MUIButton>
            <MUIButton
              variant={'contained'}
              color={'primary'}
              onClick={() => {
                if (demo) {
                  handleSubmit(state.current);
                } else {
                  onSubmit();
                }
              }}
              sx={{
                ml: '0px !important',
                width: {
                  xs: '100%',
                  md: '180px',
                },
              }}
              autoFocus
            >
              Save and Close
            </MUIButton>
          </DialogActions>
        </Dialog>
      )}

      {confirmBeforeUpdateRowDialogOpen && (
        <>
          {confirmBeforeUpdateRowDialogType === 'status' ? (
            <PendingRowUpdateStatusDialog
              open={confirmBeforeUpdateRowDialogOpen}
              data={confirmBeforeUpdateRowDialog}
              onClose={() => {
                setConfirmBeforeUpdateRowDialogOpen(false);
              }}
              onConfirm={() => {
                setConfirmBeforeUpdateRowDialogOpen(false);
                setConfirmBeforeUpdateRowDialog(null);
                onSubmit();
                setConfirmBeforeUpdateRowDialogType('');
              }}
            />
          ) : (
            <PendingRowUpdateDialog
              open={confirmBeforeUpdateRowDialogOpen}
              data={confirmBeforeUpdateRowDialog}
              onClose={() => {
                setConfirmBeforeUpdateRowDialogOpen(false);
              }}
              onConfirm={() => {
                setConfirmBeforeUpdateRowDialogOpen(false);
                setConfirmBeforeUpdateRowDialog(null);
                onSubmit();
                setConfirmBeforeUpdateRowDialogType('');
              }}
            />
          )}
        </>

      )}

      {showSendNotification && (
        <SendModification
          type={'service'}
          values={propertiesFromTable}
          onClose={() => {
            setShowSendNotification(false);
          }}
        />
      )}
    </>
  );
});

export default MinimizedContent;

function schemaHasClient<T extends Entity>(
  schema: Schema<T>
): schema is SchemaWithClient<T> {
  return 'client' in schema;
}
